module.exports = __webpack_public_path__ + "static/media/phub_outline.5fe7f74f.png";